import { makeStyles } from '@material-ui/core/styles';

export default makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    width: '100%',
  },
  Grid__container: {
    marginTop: 20,
  },
  CardHeader: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },

}));
